import { NewLead } from '../../components/leads';

const AddLead = () => <NewLead />;
export default AddLead;
